import { BaseRestDataProvider } from './BaseRestDataProvider';

export interface ProjectPhase {
  id: string;
  name: string;
  order: number;
}

export class ProjectPhasesRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/projectphases');
  }

  getAll(): Promise<ProjectPhase[]> {
    return this.get<ProjectPhase[]>(``);
  }

  getById(id: string): Promise<ProjectPhase> {
    return this.get<ProjectPhase>(`/${id}`);
  }

  create(phase: ProjectPhase): Promise<ProjectPhase> {
    return this.post<ProjectPhase>(``, phase);
  }

  update(id: string, phase: ProjectPhase): Promise<void> {
    return this.put<void>(`/${id}`, phase);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}
